    <div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">
    <p-sidebar [(visible)]="visibleUserFilter" position="right" [baseZIndex]="10000">
        <driver-centers-filter [homeDriverCentersComponent]="this"></driver-centers-filter>
        <ng-template pTemplate="header">
            <div>
                Filter
            </div>
            <hr />
        </ng-template>
    </p-sidebar>

        <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

    <div class="card">
    <!-- Table -->
        <p-table #xpressCentersGrid
                 [columns]="cols"
                 [value]="xpressCenters"
                 [lazy]="true"
                 responsiveLayout="scroll" dataKey="Id"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [loading]="loading"
                 [selection]="selectedCenters"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [rowsPerPageOptions]="rowsPerPageOptions"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'">
            <ng-template pTemplate="caption">
                <div>
                    <div class="title-float-left">
                        <div class="onboarding-head-title">
                            {{tableName}}
                        </div>
                    </div>
                    <span class="filters-panel-item flex">
                        <button class="filters-panel-item-button" pButton pRipple type="button" (click)="handleShowCreatepopup()">
                            <div class="color-aliceblue">Add New</div></button>

                        <div class="ml-4 mt-1">
                            <column-selector #columnSelector
                                 [defaultColumns]="defaultCols"
                                 (selectedColumnsChange)="onSelectedColumnsChange($event)"
                                 [tableName]="tableName"
                                 [(selectedColumns)]="cols">
                            </column-selector>
                        </div>
                    </span>
                    <span class="filters-panel-item">
                        <button pButton pRipple type="button" label="Filter" 
                                class="filters-panel-item-button p-button-outlined p-button-secondary"
                                (click)="openCentersFilter()"></button>
                    </span>
                    <span class="filters-panel-item p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" class="search-input"
                               [(ngModel)]="filter.searchName" (input)="handleFilterChange()"
                               placeholder="Search here..." />
                    </span>
                </div>
                <div class="flex flex-row sp-header"></div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th width="10px"></th>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon class="column-sorticon" [field]="col.field"></p-sortIcon>
                    </th>
                    <th width="40px">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-xpressCenter>
                <tr [pSelectableRow]="xpressCenter">
                    <td>
                        <p-tableCheckbox [value]="xpressCenter"></p-tableCheckbox>
                    </td>
                    <td *ngFor="let col of cols"
                        class="ui-resizable-column"
                        [style.width]="col.width">
                        {{xpressCenter[col.field]}}
                    </td>
                    <td>
                        <div class="flex">
                            <span class="action-icon-svg" (click)="handleInfoPopupShow(xpressCenter)">
                                <img src="../Content/xpress-app/images/svg/icon_view.svg" />
                            </span>
    
                            <span class="action-icon-svg" *ngIf="configService.config.showDeleteUser">
                                <i (click)="handleRemoveCenterPopup(xpressCenter)" class="pi pi-trash"></i>
                            </span>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="xpressCenters.length > 0" style="padding-left: 10px">
                    Displaying {{first + 1}} - {{first + xpressCenters.length}} of {{totalRecords}}
                </div>
            </ng-template>
        </p-table>
    </div>
</div>

<driver-center-info [_xpressCenter]="xpressCenter" [showPopup]="showInfoPopup" [onHide]="handleInfoPopupHide" [showEditFields]="showEditFields"></driver-center-info>
<driver-center-create [showPopup]="showCreatePopup" [onHide]="handleCreatePopupHide"></driver-center-create>

<p-dialog header="Remove Xpress Center" [(visible)]="showRemoveCenter" [modal]="true" [style]="{width: '400px'}"
          [draggable]="false" [resizable]="false">
    <p class="m-0">
        Do you really want to delete Xpress Center {{xpressCenter ? xpressCenter.Name : ""}}?<br>
        Warning: This action cannot be undone!
    </p>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-times" (click)="showRemoveCenter=false" label="Cancel" styleClass="p-button-text"></p-button>
        <p-button icon="pi pi-trash" (click)="removeXpressCenter(xpressCenter)" [disabled]="loading" label="Remove" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>

<p-toast position="top-right"></p-toast>
